export default __webpack_public_path__ + "static/media/card-home.992a4ccb.jpg";